module.exports = __webpack_public_path__ + "img/98.d3f41ecd.jpg";